import React, { Fragment, FunctionComponent } from "react";
import LinkProps from "./LinkProps.interface";

import { useDispatch } from "react-redux";
import Anchor from "components/Anchor/Anchor";
import handleOpenModal from "blocks/helpers/handleOpenModal";
import getRelativeUrl from "helpers/getRelativeUrl";

const Link: FunctionComponent<LinkProps> = (props) => {
    const dispatch = useDispatch();

    return (
        <Fragment>
            {/* Modal */}
            {props.link && (props.link.content._contentType === "modalButton" || props.link.content._contentType === "modalLink") ? (
                <Anchor aria="Modal" className={props.className} modal={props.link} onClick={() => handleOpenModal(props.link?.content.modal, props.link?.content.stickyLink, dispatch)}>
                    {props.children}
                </Anchor>
            ) : null}

            {/* Function */}
            {typeof (props.onClick) !== "undefined" && !props.link ? (
                <span className={props.className} onClick={props.onClick}>
                    {props.children}
                </span>
            ) : null}

            {/* Internal */}
            {props.link && (props.link.content._contentType === "internalLink" || props.link.content._contentType === "internalButton") ? (
                <Anchor className={props.className} to={getRelativeUrl(props.link.content.link)}>
                    {props.children}
                </Anchor>
            ) : null}

            {/* External */}
            {props.link && (props.link.content._contentType === "externalLink" || props.link.content._contentType === "externalButton") ? (
                <Anchor className={props.className} to={getRelativeUrl(props.link.content.link)}>
                    {props.children}
                </Anchor>
            ) : null}

            {/* Anchor */}
            {props.link && (props.link.content._contentType === "anchorButton" || props.link.content._contentType === "anchorLink") ? (
                <Anchor className={props.className} to={getRelativeUrl(props.link.content.anchor[0].url)}>
                    {props.children}
                </Anchor>
            ) : null}

            {/* Fallback */}
            {!props.link && !props.onClick ? (
                <div className={props.className}>
                    {props.children}
                </div>
            ) : null}
        </Fragment>
    );
};

export default Link;
